<template>
    <vx-modal :visible="!!detailingPlan"
        @update:visible="detailingPlan = null"
        size="sm"
        padding="standard">
        <template v-slot:header>
            Plan Details
        </template>
        <template v-slot:subheader>
            The plan details for the "<strong>{{ detailingPlan?.name }}</strong>" plan.
        </template>


        <h3 class="vx-mb-6 vx-font-bold">{{ detailingPlan?.name }}</h3>
        <!-- Modal Body -->
        <div v-for="(feature, index) in (detailingPlan?.features || [])"
            :key="index"
            class="vx-flex vx-items-start">
            <font-awesome-icon :icon="faCheck"
                class="vx-text-green-500 vx-mr-2 lg:-vx-ml-4"></font-awesome-icon>
            <span>{{ feature }}</span>
        </div>

        <!-- Modal Actions -->
        <template v-slot:footer>
            <div class="vx-flex vx-flex-col-reverse vx-gap-4 lg:vx-flex-row">
                <vx-button @click.prevent="
                    detailingPlan = null;
                "
                    tabindex="1"
                    type="button"
                    class="vx-grow lg:vx-w-20 lg:vx-grow-0"
                    size="lg"
                    color="muted">
                    Close
                </vx-button>
                <vx-button @click.prevent="detailingPlan = null"
                    type="button"
                    size="lg"
                    block
                    color="primary">
                    Ok
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { VxModal, VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

const detailingPlan = defineModel({
    type: Object,
    default: null
})
</script>
